<template>
  <div id="app">
    <i-header v-if="!isMobile"></i-header>
    <i-aside></i-aside>
    <home/>
  </div>
</template>

<script>
import browser from '@/utils/browser.js'
import home from "./pages/layout/home";
import aside from "./pages/layout/aside";
import header from "./pages/layout/header";
import '@/assets/css/reset.less'
import '@/assets/css/public.less'
import '@/assets/css/color.less'



export default {
  components: {
    home,
    'i-header':header,
    'i-aside':aside
  },
  data() {
    return {
      isMobile: browser.mobile
    }
  }
}
</script>

<style lang="less">
#app{
  width: 100%;
  height: 100%;
  background: #d0b19f;
  overflow: hidden;
}
</style>
